/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ViewersWatchingContainer_settings = {
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly " $refType": "ViewersWatchingContainer_settings";
};
export type ViewersWatchingContainer_settings$data = ViewersWatchingContainer_settings;
export type ViewersWatchingContainer_settings$key = {
    readonly " $data"?: ViewersWatchingContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ViewersWatchingContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewersWatchingContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "DisableCommenting",
            "kind": "LinkedField",
            "name": "disableCommenting",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'ae77a98fd69f46c6e3f9e247be9033a0';
export default node;
